import pageInitialiser from './helper/page_initialiser';
import page from '../scripts/_pages/catalog_tyre_page';
pageInitialiser(page);